import { IProjectPACETask } from '../interfaces';

export const PACE_TASK_BROWSE_FIELDS_FOR_MOMENTIZE: Array<
  keyof Omit<IProjectPACETask['projectPaceTaskData'], 'id'>
> = ['actualDate', 'forecastedDate', 'PACEActualDate', 'PACEForecastedDate'];
